/**
 * Group rows by their `month_date` and sum up the `total`.
 * Returns an array of { week, incidents } for Recharts LineChart/BarChart usage.
 */
export function groupByMonthDate(rows) {
    const grouped = rows.reduce((acc, row) => {
      const date = row.month_date;
      if (!acc[date]) {
        acc[date] = { date, sum: 0 };
      }
      acc[date].sum += row.total;
      return acc;
    }, {});
  
    return Object.values(grouped).map((item) => ({
      week: item.date,       // X-axis
      incidents: item.sum,   // Y-axis
    }));
  }
  
  /**
   * Simply maps each row to { week, students, nonStudents } for BarChart usage.
   */
  export function mapAccidentPeriod(rows) {
    // Group rows by period_id
    const grouped = rows.reduce((acc, row) => {
      const period = row.period_id;
      if (!acc[period]) {
        acc[period] = {
          period_id: period,
          students_on_bus: 0,
          no_students_on_bus: 0,
        };
      }
      acc[period].students_on_bus += row.students_on_bus;
      acc[period].no_students_on_bus += row.no_students_on_bus;
      return acc;
    }, {});
  
    // Convert the grouped object into the desired array format
    return Object.values(grouped).map((item) => ({
      week: item.period_id,
      students: item.students_on_bus,
      nonStudents: item.no_students_on_bus,
    }));
  }
  
  
  /**
   * Groups rows by their "workflow_subcategory," converting that subcategory
   * into a textual "reason," and sums the "total" field.
   * Returns an array of { reason, count } for Recharts PieChart usage.
   */
  export function groupByWorkflowSubcategory(rows, subcategoryToReasonFn) {
    const grouped = rows.reduce((acc, row) => {
      const reason = subcategoryToReasonFn(row.workflow_subcategory);
      if (!acc[reason]) {
        acc[reason] = { reason, count: 0 };
      }
      acc[reason].count += row.total;
      return acc;
    }, {});
    return Object.values(grouped);
  }
  

